import React, { Component } from "react";
import Lottie from "react-lottie";
import * as animationData from "../../assets/json/error.json";
import { Link } from "react-router-dom";

const style = {
  width: "100%",
  position: "fixed",
  height: "100%",
  backgroundColor: "#ffffff",
  zIndex: "999999",
  right: 0,
  top: 0,
};
export default class Error extends Component {
  render() {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: animationData.default,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return (
      <div style={style}>
        <Lottie
          options={defaultOptions}
          height={400}
          width={400}
          isStopped={false}
          isPaused={false}
        />
        <div style={{ width: "100%", margin: "10px auto" }}>
          <p style={{ width: "100%", textAlign: "center" }}>{this.props.txt}</p>
        </div>
        <div style={{ width: "100px", margin: "10px auto" }}>
          <Link to="/" className="btn btn-info">
            بازگشت به صفحه اصلی
          </Link>
        </div>
      </div>
    );
  }
}
